import * as actionTypes from '../services/DataCenterAutomationActionType';

const initialState = {
    isDataCenterAutomationLoading: false,
    dataCenterAutomationResponse: null,
    dataCenterAutomationError: null,
    automationList: {},
    isAutomationListLoading: false,
    automationListError: null,
    documentMappings: {},
    isDocumentMappingsLoading: false,
    documentMappingsError: null,
    isTestConnectionLoading: false,
    testConnectionResults: null,
    testConnectionError: null,
    // Export document mapping state
    isExporting: false,
    exportData: null,
    exportError: null,
};

const dataCenterAutomationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.EXPORT_DOCUMENT_MAPPING_REQUEST:
            return {
                ...state,
                isExporting: true,
                exportData: null,
                exportError: null,
            };
        case actionTypes.EXPORT_DOCUMENT_MAPPING_SUCCESS:
            return {
                ...state,
                isExporting: false,
                exportData: action.payload,
                exportError: null,
            };
        case actionTypes.EXPORT_DOCUMENT_MAPPING_FAILURE:
            return {
                ...state,
                isExporting: false,
                exportData: null,
                exportError: action.payload,
            };
        case actionTypes.DATA_CENTER_AUTOMATION_SAVE_BULK_REQUEST:
            return {
                ...state,
                isDataCenterAutomationLoading: true,
                dataCenterAutomationError: null,
                dataCenterAutomationResponse: null,
            };
        case actionTypes.DATA_CENTER_AUTOMATION_SAVE_BULK_SUCCESS:
            return {
                ...state,
                isDataCenterAutomationLoading: false,
                dataCenterAutomationResponse: action.payload,
                dataCenterAutomationError: null,
            };
        case actionTypes.DATA_CENTER_AUTOMATION_SAVE_BULK_FAILURE:
            return {
                ...state,
                isDataCenterAutomationLoading: false,
                dataCenterAutomationError: action.payload,
            };
        case actionTypes.DATA_CENTER_AUTOMATION_LIST_REQUEST:
            return {
                ...state,
                isAutomationListLoading: true,
                automationListError: null,
            };
        case actionTypes.DATA_CENTER_AUTOMATION_LIST_SUCCESS:
            return {
                ...state,
                isAutomationListLoading: false,
                automationList: action.payload,
                automationListError: null,
            };
        case actionTypes.DATA_CENTER_AUTOMATION_LIST_FAILURE:
            return {
                ...state,
                isAutomationListLoading: false,
                automationListError: action.payload,
            };
        case actionTypes.DOCUMENT_MAPPINGS_REQUEST:
            return {
                ...state,
                isDocumentMappingsLoading: true,
                documentMappingsError: null,
            };
        case actionTypes.DOCUMENT_MAPPINGS_SUCCESS:
            return {
                ...state,
                isDocumentMappingsLoading: false,
                documentMappings: action.payload,
                documentMappingsError: null,
            };
        case actionTypes.DOCUMENT_MAPPINGS_FAILURE:
            return {
                ...state,
                isDocumentMappingsLoading: false,
                documentMappingsError: action.payload,
            };
        case actionTypes.FOLDER_PATH_TEST_CONNECTION_REQUEST:
            return {
                ...state,
                isTestConnectionLoading: true,
                testConnectionError: null,
            };
        case actionTypes.FOLDER_PATH_TEST_CONNECTION_SUCCESS:
            return {
                ...state,
                isTestConnectionLoading: false,
                testConnectionResults: action.payload,
                testConnectionError: null,
            };
        case actionTypes.FOLDER_PATH_TEST_CONNECTION_FAILURE:
            return {
                ...state,
                isTestConnectionLoading: false,
                testConnectionError: action.payload,
            };
        default:
            return state;
    }
};

export default dataCenterAutomationReducer;
